import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TriangleArrowIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.triangleIcon}`}
        data-testid={testId}
        fill='none'
        height='12'
        viewBox='-0.5 0 12 12'
        width='12'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M6.19764 9.25C5.81274 9.91667 4.85049 9.91667 4.46559 9.25L0.135466 1.75C-0.249434 1.08333 0.231692 0.25 1.00149 0.25L9.66175 0.250001C10.4315 0.250001 10.9127 1.08333 10.5278 1.75L6.19764 9.25Z'
            fill='currentColor'
        />
    </svg>
);

export default TriangleArrowIcon;
